import React from 'react';

function Booking() {
    return <h2>Booking WIP</h2>;
}

export default Booking;